"use client"
import styled from "@emotion/styled"
import { Box, Button } from "@mui/material"
import { useState } from "react"
import { NewText } from "ui"
import { sharedColors } from "ui/theme/colors"
import FormComponent from "./FormComponent"

const StyledSection = styled.section`
  width: 100%;
  padding: 24px 0;
  border-radius: 16px;
  background: #fff;
  margin-bottom: 40px;

  /* Card Dark */
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.16);
  background: var(--White, #fff);
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 32px 0;
    margin-bottom: unset;
  }
`

const StyledTopSection = styled.div`
  padding: 0 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 0 32px;
  }
`

const StyledSwitchButtons = styled(Button)<{ $active: boolean }>`
  padding: 8.5px 6px;
  display: inline-flex;
  gap: 6px;
  justify-content: center;
  border-radius: 8px;
  background: ${(p) => (p.$active ? "var(--Blue-Main, #2768a3)" : "transparent")};
  color: ${(p) => (p.$active ? "#FFFFFF" : "black")};
  margin: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: ${(p) => (p.$active ? "700" : "400")};
  line-height: 23px;
  text-decoration: none;
  min-width: 96px;
  height: 39px;
  white-space: nowrap;
  svg,
  path {
    fill: inherit;
  }
  svg {
    height: 22px;
    width: 30px;
    min-width: 30px;
  }
  :hover {
    text-decoration: none !important;
    background: ${(p) => (p.$active ? "var(--Blue-Main, #2768a3)" : "transparent")};
    color: ${(p) => (p.$active ? "#FFFFFF" : "black")};
  }
  @media (min-width: 370px) {
    width: unset;
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    min-width: 163px;
    height: 42px;
    font-size: 18px;
    line-height: 26px;
    padding: 8px 12px;
  }
`

type Props = {
  orderId: number
  jobType?: any
  messages?: any
  setModalOpen?: any
}

const FormSection = ({ orderId, jobType, messages }: Props) => {
  const [formType, setFormType] = useState<"regular" | "employee">("regular")
  return (
    <StyledSection>
      <StyledTopSection>
        <NewText
          component="p"
          desktopFontSize={32}
          desktopLineHeight="36px"
          desktopFontWeight={"700"}
          color={sharedColors.black}
        >
          {"בואו לעבוד איתנו"}
        </NewText>
        <Box
          sx={{
            padding: "8px",
            backgroundColor: "#F7F7F7",
            display: "flex",
            margin: "20px 0",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: "12px",
            "@media (min-width:370px)": {
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
            },
            "@media (min-width:600px)": {
              margin: "24px 0",
              display: "inline-flex !important",
            },
          }}
        >
          <StyledSwitchButtons
            sx={{
              fill: formType === "employee" ? "black" : "#6F6F6F",
            }}
            $active={formType === "regular"}
            onClick={() => setFormType("regular")}
          >
            מעוניין/ת להצטרף
          </StyledSwitchButtons>
          <StyledSwitchButtons
            //TODO: Change to visible when employee referral form is ready
            sx={{
              fill: formType === "regular" ? "black" : "#6F6F6F",
            }}
            $active={formType === "employee"}
            onClick={() => setFormType("employee")}
          >
            חבר מביא חבר
          </StyledSwitchButtons>
        </Box>
      </StyledTopSection>
      <FormComponent
        orderId={orderId}
        jobType={jobType}
        messages={messages}
        isReferral={formType === "employee"}
      />
    </StyledSection>
  )
}

export default FormSection
